(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
(function () {
  document.querySelectorAll('.quantity-selector__btn[data-action]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById(this.dataset.target);
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      input.value = this.dataset.action === 'increment' ? val + 1 : Math.max(0, val - 1);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var toggle  = document.getElementById('MobileNavToggle');
  var close   = document.getElementById('MobileNavClose');
  var nav     = document.getElementById('MobileNav');
  var overlay = document.getElementById('MobileNavOverlay');

  if (!toggle || !nav) return;

  function openNav() {
    nav.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    if (close) close.focus();
  }

  function closeNav() {
    nav.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    toggle.focus();
  }

  toggle.addEventListener('click', openNav);
  if (close) close.addEventListener('click', closeNav);
  if (overlay) overlay.addEventListener('click', closeNav);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.getAttribute('aria-hidden') === 'false') {
      closeNav();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vdg-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.vdg-sort-select').forEach(function(select) {
    select.addEventListener('change', function() {
      var base = this.dataset.sortUrl || window.location.pathname;
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', this.value);
      params.delete('page');
      window.location = base + '?' + params.toString();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vdg-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('.vdg-faq__accordion').forEach(function(faq) {
    faq.querySelectorAll('.accordion__trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var body = btn.closest('.accordion__item').querySelector('.accordion__body');
        body.setAttribute('aria-hidden', String(expanded));
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vdg-main-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var wrappers = document.querySelectorAll('.vdg-product__form-wrapper');

  wrappers.forEach(function(wrapper) {
    var sectionId = wrapper.dataset.sectionId;
    var moneyFormat = wrapper.dataset.moneyFormat || '${{amount}}';
    var variantsEl = document.getElementById('VdgProductVariants-' + sectionId);
    if (!variantsEl) return;

    var variants = JSON.parse(variantsEl.textContent);
    var mainImage = document.getElementById('VdgMainImage-' + sectionId);
    var priceWrap = document.getElementById('VdgPrice-' + sectionId);
    var submitBtn = document.getElementById('VdgAddToCart-' + sectionId);
    var hiddenInput = wrapper.querySelector('[name="id"]');
    var selects = wrapper.querySelectorAll('.vdg-variant-select');
    var gallery = document.getElementById('VdgGallery-' + sectionId);
    var thumbs = gallery ? gallery.querySelectorAll('[data-image-id]') : [];
    var mainWrap = gallery ? gallery.querySelector('.vdg-product__main-image-wrap') : null;

    var images = Array.from(thumbs).map(function(btn) {
      return { id: btn.dataset.imageId, src: btn.dataset.imageSrc, alt: btn.dataset.imageAlt };
    });
    var currentIndex = 0;
    thumbs.forEach(function(btn, i) {
      if (btn.classList.contains('is-active')) currentIndex = i;
    });
    var isAnimating = false;

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{ amount }}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }

    function setThumb(idx) {
      thumbs.forEach(function(btn) {
        btn.classList.toggle('is-active', btn.dataset.imageId === images[idx].id);
      });
    }

    function makeSlide(src, alt) {
      var el = document.createElement('img');
      el.className = 'vdg-product__main-img';
      el.src = src;
      el.alt = alt || '';
      el.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;transition:none;';
      return el;
    }

    // Central navigation function. All entry points (thumbs, arrows, swipe, variant) funnel here.
    // prebuilt: {img} — drag-created incoming element already in DOM and already positioned.
    function goToIndex(nextIdx, dir, prebuilt) {
      if (isAnimating) return;
      if (nextIdx === currentIndex && !prebuilt) return;
      if (!mainWrap || !mainImage) return;
      isAnimating = true;

      var wrapW = mainWrap.offsetWidth;
      var outgoing = mainImage;
      var incoming;

      if (prebuilt) {
        incoming = prebuilt.img;
        // Both elements are already absolutely positioned at the drag's last offset.
      } else {
        incoming = makeSlide(images[nextIdx].src, images[nextIdx].alt);
        outgoing.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;transition:none;transform:translateX(0);';
        incoming.style.transform = 'translateX(' + (dir > 0 ? wrapW : -wrapW) + 'px)';
        mainWrap.insertBefore(incoming, outgoing);
      }

      // Flush layout so transitions start from the current painted position.
      incoming.getBoundingClientRect();

      var tx = 'transform 0.35s ease';
      outgoing.style.transition = tx;
      incoming.style.transition = tx;
      outgoing.style.transform = 'translateX(' + (dir > 0 ? -wrapW : wrapW) + 'px)';
      incoming.style.transform = 'translateX(0)';

      incoming.addEventListener('transitionend', function done() {
        incoming.removeEventListener('transitionend', done);
        outgoing.remove();
        incoming.removeAttribute('style');
        incoming.id = 'VdgMainImage-' + sectionId;
        mainImage = incoming;
        currentIndex = nextIdx;
        setThumb(nextIdx);
        isAnimating = false;
      }, { once: true });
    }

    function snapBack(dragImg, dir) {
      isAnimating = true;
      var wrapW = mainWrap.offsetWidth;
      var tx = 'transform 0.3s ease';
      mainImage.style.transition = tx;
      mainImage.style.transform = 'translateX(0)';
      dragImg.style.transition = tx;
      dragImg.style.transform = 'translateX(' + (dir > 0 ? wrapW : -wrapW) + 'px)';
      dragImg.addEventListener('transitionend', function done() {
        dragImg.removeEventListener('transitionend', done);
        dragImg.remove();
        mainImage.removeAttribute('style');
        isAnimating = false;
      }, { once: true });
    }

    function updateVariant(variant) {
      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.dataset.unavailable || 'Unavailable';
        }
        return;
      }

      if (hiddenInput) hiddenInput.value = variant.id;

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      if (priceWrap) {
        var priceHTML;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHTML = '<span class="price price--large price--sale">' + formatMoney(variant.price) + '</span>'
            + '<span class="price price--compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          priceHTML = '<span class="price price--large">' + formatMoney(variant.price) + '</span>';
        }
        var existingServingCount = priceWrap.querySelector('.price__serving-count');
        priceWrap.innerHTML = priceHTML;
        if (existingServingCount) priceWrap.appendChild(existingServingCount);
      }

      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.add || 'Add to cart';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.dataset.soldout || 'Sold out';
        }
      }

      if (variant.featured_image) {
        var vImgIdx = images.findIndex(function(img) { return img.id === String(variant.featured_image.id); });
        if (vImgIdx !== -1 && vImgIdx !== currentIndex) {
          goToIndex(vImgIdx, vImgIdx > currentIndex ? 1 : -1);
        }
      }
    }

    selects.forEach(function(select) {
      select.addEventListener('change', function() {
        var selectedOptions = Array.from(selects).map(function(s) { return s.value; });
        var matched = variants.find(function(v) {
          return v.options.every(function(opt, i) { return opt === selectedOptions[i]; });
        });
        updateVariant(matched || null);
      });
    });

    thumbs.forEach(function(btn, i) {
      btn.addEventListener('click', function() {
        goToIndex(i, i > currentIndex ? 1 : -1);
      });
    });

    if (mainWrap) {
      var prevBtn = mainWrap.querySelector('.vdg-product__arrow--prev');
      var nextBtn = mainWrap.querySelector('.vdg-product__arrow--next');
      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToIndex((currentIndex - 1 + images.length) % images.length, -1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToIndex((currentIndex + 1) % images.length, 1);
        });
      }
    }

    if (mainWrap && images.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var dragState = null;
      var dragLocked = false;

      mainWrap.addEventListener('touchstart', function(e) {
        if (isAnimating) return;
        if (e.target.closest('.vdg-product__arrow')) return;
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        dragState = null;
        dragLocked = false;
      }, { passive: true });

      mainWrap.addEventListener('touchmove', function(e) {
        if (isAnimating || !mainImage) return;
        var touch = e.changedTouches[0];
        var dx = touch.screenX - touchStartX;
        var dy = touch.screenY - touchStartY;

        // Lock to horizontal once intent is clear; ignore vertical-dominant gestures.
        if (!dragLocked) {
          if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
          if (Math.abs(dy) >= Math.abs(dx)) return;
          dragLocked = true;
        }

        var wrapW = mainWrap.offsetWidth;
        var dir = dx < 0 ? 1 : -1;
        var adjIdx = dir > 0
          ? (currentIndex + 1) % images.length
          : (currentIndex - 1 + images.length) % images.length;

        if (!dragState) {
          var img = makeSlide(images[adjIdx].src, images[adjIdx].alt);
          img.style.transform = 'translateX(' + (dir > 0 ? wrapW : -wrapW) + 'px)';
          mainImage.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;transition:none;';
          mainWrap.insertBefore(img, mainImage);
          dragState = { img: img, dir: dir, adjIdx: adjIdx };
        } else if (dragState.dir !== dir) {
          // User reversed direction mid-drag — reset and start fresh.
          dragState.img.remove();
          mainImage.removeAttribute('style');
          dragState = null;
          dragLocked = false;
          touchStartX = touch.screenX;
          touchStartY = touch.screenY;
          return;
        }

        mainImage.style.transform = 'translateX(' + dx + 'px)';
        dragState.img.style.transform = 'translateX(' + (dir > 0 ? wrapW + dx : -wrapW + dx) + 'px)';
      }, { passive: true });

      mainWrap.addEventListener('touchend', function(e) {
        if (isAnimating || !dragState) return;
        var dx = e.changedTouches[0].screenX - touchStartX;
        var dy = e.changedTouches[0].screenY - touchStartY;
        var state = dragState;
        dragState = null;
        dragLocked = false;

        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
          goToIndex(state.adjIdx, state.dir, { img: state.img });
        } else {
          snapBack(state.img, state.dir);
        }
      }, { passive: true });
    }

    var quantityBtns = wrapper.querySelectorAll('.quantity-selector__btn');
    quantityBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var input = this.closest('.quantity-selector').querySelector('.quantity-selector__input');
        var val = parseInt(input.value, 10) || 1;
        if (this.dataset.action === 'increment') {
          input.value = val + 1;
        } else {
          input.value = Math.max(1, val - 1);
        }
      });
    });
  });
})();

(function() {
  var tabGroups = document.querySelectorAll('.vdg-tabs');

  tabGroups.forEach(function(group) {
    var tabs = Array.from(group.querySelectorAll('.vdg-tabs__tab'));
    var panels = Array.from(group.querySelectorAll('.vdg-tabs__panel'));

    function activate(idx, focus) {
      tabs.forEach(function(tab, i) {
        var selected = i === idx;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (panels[i]) panels[i].hidden = !selected;
      });
      if (focus) tabs[idx].focus();
    }

    tabs.forEach(function(tab, i) {
      tab.addEventListener('click', function() {
        activate(i, false);
      });
      tab.addEventListener('keydown', function(e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          e.preventDefault();
          activate(next, true);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
